import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Pressable from '@atlaskit/primitives/pressable';
import { xcss } from '@atlaskit/primitives/xcss';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import ChartTrendUpIcon from '@atlaskit/icon/core/chart-trend-up';

const badgeStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 'space.050',

	color: 'color.text.subtle',
	font: 'font.body.small',
	backgroundColor: 'elevation.surface',
	borderRadius: 'radius.small',
	paddingLeft: 'space.050',
	paddingRight: 'space.050',
	paddingTop: 'space.025',
	paddingBottom: 'space.025',
	height: '24px',

	':hover': {
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},
	':active': {
		backgroundColor: 'color.background.neutral.subtle.pressed',
	},
});

type BadgeStyleAnalyticsBylineProps = {
	message: React.ReactNode | string;
	onClick?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	iconLabel: string;
};

export const BadgeStyleAnalyticsByline = ({
	message,
	onClick,
	iconLabel,
}: BadgeStyleAnalyticsBylineProps): React.JSX.Element => (
	<Pressable onClick={onClick} xcss={badgeStyles} testId="badge-style-analytics-byline">
		<ChartTrendUpIcon label={iconLabel} />
		{message}
	</Pressable>
);
